import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("session_token");
  if (token) {
    config.headers["X-Session-Token"] = token;
  }

  return config;
});


export default api;
